import { types, applySnapshot } from 'mobx-state-tree';
import Framework from '@greenville/framework';
import * as constants from '../../../common/constants';

const typesData = types.model('typesData', {
  bookId: types.maybeNull(types.string),
  identifierId: types.maybeNull(types.string),
  requestId: types.maybeNull(types.string),
  type: types.maybeNull(types.string)
});

const GetSubtypesModel = types
  .model('GetSubtypesModel', {
    data: types.optional(types.array(typesData), [])
  })
  .actions((self) => ({
    fetch(payload) {
      Framework.getEventManager().publish(constants.GET_CHATGPT_TYPE_RESPONSE_DATA, {
        payload
      });
    },
    setResponse(response) {
      // Normalize common API shapes into an array for this model
      let nextData = [];
      if (Array.isArray(response)) {
        nextData = response;
      } else if (response && Array.isArray(response.data)) {
        nextData = response.data;
      } else if (response && response.result && Array.isArray(response.result)) {
        nextData = response.result;
      } else if (response && response.items && Array.isArray(response.items)) {
        nextData = response.items;
      }

      applySnapshot(self.data, nextData);
      Framework.getEventManager().publish(constants.SET_CHATGPT_TYPE_RESPONSE_DATA);
    },
    resetStoreValues() {
      const initialState = [];
      applySnapshot(self.data, initialState);
    }
  }));

export default GetSubtypesModel;
